if (!customElements.get('m-child-collections')) {
  class MChildCollections extends HTMLElement {
    connectedCallback() {
      this.enableSlider = this.dataset.enableSlider === 'true';
      if (!this.enableSlider) return;

      const track = this.querySelector('[data-track]');
      if (!track) return;
      track.classList.add('swiper-wrapper');

      this.initSlider();
    }

    initSlider() {
      const slideContainer = this.querySelector('.swiper-container');
      if (!slideContainer || typeof MinimogLibs === 'undefined' || !MinimogLibs.Swiper) return;

      const items = parseFloat(this.dataset.items) || 4.5;
      const itemsMobile = parseFloat(this.dataset.itemsMobile) || 3;
      const autoplay = this.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5;

      const tabletItems = Math.max(2, Math.min(items, Math.ceil(items / 2) + 0.5));
      const isCircle = this.dataset.cardStyle === 'circle';
      const desktopSpaceBetween = isCircle ? 24 : 40;
      const mobileSpaceBetween = isCircle ? 6 : 16;
      const mobileView = isCircle ? 5 : itemsMobile;
      const tabletView = isCircle ? 5 : tabletItems;
      const desktopView = isCircle ? 5 : items;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: mobileView,
        slidesPerGroup: 1,
        spaceBetween: mobileSpaceBetween,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 16,
        watchOverflow: true,
        autoplay: autoplay
          ? { delay: autoplaySpeed * 1000, disableOnInteraction: false }
          : false,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
          bulletClass: 'm-dot',
          bulletActiveClass: 'm-dot--active',
        },
        breakpoints: {
          768: {
            slidesPerView: tabletView,
            spaceBetween: 24,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          1024: {
            slidesPerView: desktopView,
            spaceBetween: desktopSpaceBetween,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      });
    }
  }

  customElements.define('m-child-collections', MChildCollections);
}
